"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _Complete = _interopRequireDefault(require("@p24/icons/Complete"));

function _default(palette) {
  return {
    fontSize: palette.tsSmall,
    fontWeight: palette.twSemi,
    color: palette.tHint,
    whiteSpace: 'nowrap',
    activeColor: palette.tAccent,
    passedColor: palette.tAccent,
    number: {
      width: palette.gutter * 3 + 'px',
      height: palette.gutter * 3 + 'px',
      borderRadius: '50%',
      background: palette.elDarkest,
      color: palette.tInversion,
      icon: null,
      marginRight: palette.gutter + 'px',
      activeBackground: palette.elAccent,
      activeColor: palette.tInversion,
      activeIcon: null,
      passedBackground: palette.elAccent,
      passedColor: palette.tInversion,
      passedIcon: _Complete["default"]
    },
    hint: {
      fontSize: palette.tsXSmall,
      lineHeight: palette.tlXSmall,
      fontWeight: palette.twNormal,
      color: palette.tHint,
      activeColor: palette.tHint,
      passedColor: palette.tHint
    },
    divider: {
      background: palette.elDivider,
      width: palette.gutter * 9 + 'px',
      padding: palette.gutter + 'px',
      height: '2px'
    }
  };
}